import { AtendimentoIndividualInput, RetificacaoAtendimentoInput } from 'graphql/types.generated'
import { RetificacaoAtendimentoState } from 'view/atendimentos/model-atendimento'

export const convertAtendimentoIndividualInputToRetificacaoAtendimentoInput = (
  atendimentoRetificadoInput: AtendimentoIndividualInput,
  atendimentoProfissionalId: string,
  retificacaoAtendimentoState: RetificacaoAtendimentoState
): RetificacaoAtendimentoInput => ({
  atendimentoRetificadoInput,
  inativarAtendimentoInput: {
    atendimentoProfissionalId,
    historicoCabecalhoId: retificacaoAtendimentoState.historicoCabecalhoId,
    justificativa: retificacaoAtendimentoState.justificativa,
  },
})
